export default {
  menu: {
    plans: 'bottomMenu.plans',
    product: 'bottomMenu.product',
    contact: 'bottomMenu.contact',
    freeTrial: 'bottomMenu.freeTrial',
  },
  title: 'confirmSuccess.title',
  desc: 'confirmSuccess.desc',
};
